import { styled } from "styled-components";

export const Wrapper = styled.section`
  transition: 0.6s ease-in-out all;
  overflow: hidden;
  cursor: pointer;
  width: 8rem;
  height: 8rem;
  border-radius: 10px;

  &:hover {
    height: 8.1rem;
    box-shadow: 0px 0px 50px 5px #000;
  }
  @media screen and (max-width: 700px) {
    width: 6rem;
    height: 6rem;
    .icon {
      width: 2rem;
      height: 2rem;
    }
    &:hover {
      height: 6.1rem;
    }
  }
`;

export const SkillContainer = styled.div`
  border-radius: 10px;
  background-color: #3182ce;
  width: 100%;
  height: 100%;
  box-shadow: var(--shadow-2);
  transition: 0.3s ease-in-out all;

  &:hover {
    padding-top: 5px;
  }
`;

export const Skill = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  background-color: #1b1b1b;

  .icon {
    width: 2.5rem;
    height: 2.5rem;
    color: var(--white);
    margin-top: 1.5rem;
  }
  .jira {
    color: #257ff7;
  }
  .js {
    color: #f7d803;
  }
  .css3 {
    color: #2191ec;
  }
  .html5 {
    color: #f75420;
  }
  .reactjs {
    color: #57d2f5;
  }
  .nextjs {
    color: #fff;
  }
  .typescript {
    color: #2f73bf;
  }
  .redux {
    color: #9a76d4;
  }
  .tailwind {
    color: #36b6f0;
  }
  .bootstrap {
    color: #7911f2;
  }
  .figma {
    color: #fff;
  }
  .sass {
    color: #e43f76;
  }
  .nodejs {
    color: #87c148;
  }
  .laravel {
    color: #f72419;
  }
  .expressjs {
    color: #fff;
  }
  .mysql {
    color: #41b1f7;
  }
  .mongodb {
    color: #14a450;
  }
  .firebase {
    color: #f5be05;
  }

  .vercel {
    color: #fff;
  }
  .render {
    color: #4351e7;
  }
  .netlify {
    color: #27bbb5;
  }
  .git {
    color: #e84d32;
  }
  .github {
    color: #fff;
  }
  .postman {
    color: #f76836;
  }
  .jest {
    color: #c3441a;
  }
  .vscode {
    color: #43a6ed;
  }
  .npm {
    color: #c43635;
  }
`;
